import { getStatus, ApprovalStatusPattern } from "../default-constants";
import { LABELS } from "./constants";

// 契約ステータスを文字に変換
export const getContractStatusLog = (flag: boolean) => {
  if (flag === null) return "";
  if (flag) return LABELS.CONTRACT_STATUS_STOPPED;
  else return LABELS.CONTRACT_STATUS_NOT_STOPPED;
};
// ステータスを文字に変換
export const getStatusLoc = (status: number) => {
  if (ApprovalStatusPattern.beforeApproval.statusCode === status)
    return LABELS.UN_APPLICATION;
  return getStatus(status);
};
// 設定値を文字に変換
export const getSettingValueLoc = (settingValue: number) => {
  if (settingValue === 1) return LABELS.UN_SETTING;
  if (settingValue === 2) return LABELS.DO_SETTING;
  if (settingValue === 0) return "ー";
  return "";
};
// 接続環境・実装確認のLINK判定
export const isLink = (connectionValue: any, isDocomoUser: boolean) => {
  // 未申請＆GW事業者ユーザ
  if (
    connectionValue === ApprovalStatusPattern.beforeApproval.statusCode &&
    !isDocomoUser
  ) {
    return true;
  }
  // 承認待＆ドコモユーザ
  if (
    connectionValue === ApprovalStatusPattern.awaitingApproval.statusCode &&
    isDocomoUser
  ) {
    return true;
  }
  return false;
};
// IPID事前払出のLINK判定
export const isLinkIpidValue = (ipidValue: any) => {
  // 未設定
  if (ipidValue === 1) {
    return true;
  }
  return false;
};
